import type { TypeRateWithDetail } from '~/types/delivery-agency.types';

export const toSectionItemData = (
  rateWithDetail: TypeRateWithDetail | null | undefined,
  primaryColor: string,
  secondaryColor?: string
) => {
  if (!rateWithDetail) return [];

  if (rateWithDetail.details.length > 0) {
    return rateWithDetail.details.map((detail, index) => ({
      label: detail.label,
      rate: detail.rate,
      progressColor: index % 2 === 0 ? primaryColor : (secondaryColor ?? primaryColor),
    }));
  }

  return [{ label: '', rate: rateWithDetail.rate, progressColor: primaryColor }];
};
